import {performHttpRequest} from "../http";

export async function getPresentationCategory(bookmarkPresentationID, data) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/bookmarkpresentation/' + bookmarkPresentationID + '/category',
        'GET',
    )
}
